/* tslint:disable */
/* eslint-disable */
import { PaymentDisplayModel as AceXFoundPortalCoreCaqModelsPaymentDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/payment-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { PaymentDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsPaymentDisplayModelFormGroup } from '@/api/model-index';

export interface IPaymentFoerdersummenDisplayModel {
  ausstehendeZahlungen?: null | number;
  foerdersummeBewilligt?: null | number;
  foerdersummeOffen?: null | number;
  getaetigteZahlungen?: null | number;
  id?: string;
  payments?: null | Array<AceXFoundPortalCoreCaqModelsPaymentDisplayModel>;
  rueckzahlungen?: null | number;
}
export class PaymentFoerdersummenDisplayModel extends BaseModel implements IPaymentFoerdersummenDisplayModel {
  ausstehendeZahlungen?: null | number;
  foerdersummeBewilligt?: null | number;
  foerdersummeOffen?: null | number;
  getaetigteZahlungen?: null | number;
  id?: string;
  payments?: null | Array<AceXFoundPortalCoreCaqModelsPaymentDisplayModel>;
  rueckzahlungen?: null | number;
}
class BasePaymentFoerdersummenDisplayModelFormGroup extends FormGroup {
  private static _instance: PaymentFoerdersummenDisplayModelFormGroup;
  
  public static get Instance(): PaymentFoerdersummenDisplayModelFormGroup {
    this._instance = new PaymentFoerdersummenDisplayModelFormGroup({
      ausstehendeZahlungen: new FormControl(null),
      foerdersummeBewilligt: new FormControl(null),
      foerdersummeOffen: new FormControl(null),
      getaetigteZahlungen: new FormControl(null),
      id: new FormControl(null),
      payments: new FormArray([]),
      rueckzahlungen: new FormControl(null),
    });

    return this._instance;
  }
}


export class PaymentFoerdersummenDisplayModelFormGroup extends BasePaymentFoerdersummenDisplayModelFormGroup {
  public get AusstehendeZahlungen(): FormControl {
    return this.controls["ausstehendeZahlungen"] as FormControl;
  }
  public get FoerdersummeBewilligt(): FormControl {
    return this.controls["foerdersummeBewilligt"] as FormControl;
  }
  public get FoerdersummeOffen(): FormControl {
    return this.controls["foerdersummeOffen"] as FormControl;
  }
  public get GetaetigteZahlungen(): FormControl {
    return this.controls["getaetigteZahlungen"] as FormControl;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Payments(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsPaymentDisplayModelFormGroup> {
    return this.controls["payments"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsPaymentDisplayModelFormGroup>;
  }
  public get Rueckzahlungen(): FormControl {
    return this.controls["rueckzahlungen"] as FormControl;
  }
  

}

export module PaymentFoerdersummenDisplayModelForm
  {
    export class FormFields
    {
      static _ausstehendeZahlungen: string = "ausstehendeZahlungen";
      static _foerdersummeBewilligt: string = "foerdersummeBewilligt";
      static _foerdersummeOffen: string = "foerdersummeOffen";
      static _getaetigteZahlungen: string = "getaetigteZahlungen";
      static _id: string = "id";
      static _payments: string = "payments";
      static _rueckzahlungen: string = "rueckzahlungen";
    }
  }

